import usePost from "./usePost";

function useCustomCTA() {
  const { customCTA } = usePost();

  if (!customCTA) {
    return null;
  }

  const [text, link, btnText] = customCTA;

  return { text, link, btnText };
}

export default useCustomCTA;
